import { render } from "./MenuForm.vue?vue&type=template&id=01c13943"
import script from "./MenuForm.vue?vue&type=script&lang=js"
export * from "./MenuForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__